import API from "utils/API";
import authHeader from "utils/auth-header";
import { IResponseBuildings } from "../domain/IResponseBuildings";
import { IBuildingCreate } from "../domain/IBuildingCreate";
import { ISalesUnitCreate } from "../domain/ISalesUnitCreate";
import { IResponseSalesUnit } from "../domain/IResponseSalesUnit";
import { IProjectFinancials } from "Dashboard/scenes/Projects/domain/IProjectFinancials";
import { IType } from "Dashboard/domain/IType";
import { IBuildingUpdate } from "../domain/IBuildingUpdate";
import { IStatus } from "Dashboard/domain/IStatus";
import { ISalesUnitUpdate } from "../domain/ISalesUnitUpdate";
import { IMessage } from "domain/IMessage";
import { ISalesUnitFinancials } from "../domain/ISalesUnitFinancials";
import { IBuildingWithSalesUnits } from "../domain/IBuildingWithSalesUnits";
import { IGetFinancialsRequestParams } from "../domain/IGetFinancialsRequestParams";
import { getQeuryParams } from "utils/queryParamsUtil";
import { IConsumableExemptionFinancials } from "Dashboard/scenes/Projects/domain/IConsumableExemptionFinancials";
import { IConcreteBaseFinancials } from "Dashboard/scenes/Projects/domain/IConcreteBaseFinancials";
import { IGetBuildingsListRequestParams } from "../domain/IGetBuildingsListRequestParams";
import { IGetSalesUnitFinancialsRequestParams } from "../domain/IGetSalesUnitFinancialsRequestParams";

const getAllBuildings = async (
  search: IGetBuildingsListRequestParams | undefined
): Promise<IResponseBuildings> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResponseBuildings>(
      `/high-rise-sales/protected/building${getQeuryParams(search)}`,
      { headers }
    );
    let buildings = response.data;
    return buildings;
  } catch (err) {
    throw err;
  }
};

const createBuilding = async (
  data: IBuildingCreate
): Promise<IResponseBuildings> => {
  var headers = authHeader();
  try {
    const response = await API.post<IResponseBuildings>(
      "/high-rise-sales/protected/building",
      data,
      { headers }
    );
    let building = response.data;
    return building;
  } catch (err) {
    throw err;
  }
};

const updateBuilding = async (
  data: IBuildingUpdate
): Promise<IBuildingWithSalesUnits> => {
  var headers = authHeader();
  const { buildingId, ...rest } = data;
  try {
    const response = await API.put<IBuildingWithSalesUnits>(
      `/high-rise-sales/protected/building/${buildingId}`,
      rest,
      { headers }
    );
    let item = response.data;
    return item;
  } catch (err) {
    throw err;
  }
};

const deleteBuilding = async (buildingId: number): Promise<IMessage> => {
  var headers = authHeader();
  try {
    const response = await API.delete<IMessage>(
      `/high-rise-sales/protected/building/${buildingId}`,
      { headers }
    );
    let message = response.data;
    return message;
  } catch (err) {
    throw err;
  }
};

const createSalesUnit = async (
  data: ISalesUnitCreate
): Promise<IResponseSalesUnit> => {
  var headers = authHeader();
  try {
    const response = await API.post<IResponseSalesUnit>(
      "/high-rise-sales/protected/sales-unit",
      data,
      { headers }
    );
    let salesUnit = response.data;
    return salesUnit;
  } catch (err) {
    throw err;
  }
};

const updateSalesUnit = async (
  data: ISalesUnitUpdate
): Promise<IBuildingWithSalesUnits> => {
  var headers = authHeader();
  const { salesUnitId, buildingId, ...rest } = data;
  try {
    const response = await API.put<IBuildingWithSalesUnits>(
      `/high-rise-sales/protected/sales-unit/${buildingId}/${salesUnitId}`,
      rest,
      { headers }
    );
    let item = response.data;
    return item;
  } catch (err) {
    throw err;
  }
};

const deleteSalesUnit = async (
  buildingId: number,
  salesUnitId: number
): Promise<IBuildingWithSalesUnits> => {
  var headers = authHeader();
  try {
    const response = await API.delete<IBuildingWithSalesUnits>(
      `/high-rise-sales/protected/sales-unit/${buildingId}/${salesUnitId}`,
      { headers }
    );
    let item = response.data;
    return item;
  } catch (err) {
    throw err;
  }
};

const getSalesUnitTypes = async (): Promise<IType[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IType[]>(`/high-rise-sales/protected/sales-unit-type`, {
      headers,
    });
    let types = response.data;
    return types;
  } catch (err) {
    throw err;
  }
};

const getBuildingFinancials = async (
  data: IGetFinancialsRequestParams
): Promise<IProjectFinancials> => {
  var headers = authHeader();
  try {
    const { buildingId, ...otherData } = data;
    const response = await API.get<IProjectFinancials>(
      `/high-rise-sales/protected/building/${buildingId}/financials${getQeuryParams(otherData)}`,
      { headers }
    );
    let financials = response.data;
    return financials;
  } catch (err) {
    throw err;
  }
};

const getBuildingsConsumableFinancials = async (
  data: IGetFinancialsRequestParams
): Promise<IConsumableExemptionFinancials> => {
  var headers = authHeader();
  try {
    const { buildingId, ...otherData } = data;
    const response = await API.get<IConsumableExemptionFinancials>(
      `/high-rise-sales/protected/building/${buildingId}/financials/consumables${getQeuryParams(otherData)}`,
      { headers }
    );
    let consumableExemptionFinancials = response.data;
    return consumableExemptionFinancials;
  } catch (err) {
    throw err;
  }
};

const getBuildingConcreteBaseFinancials = async (
  data: IGetFinancialsRequestParams
): Promise<IConcreteBaseFinancials> => {
  var headers = authHeader();
  try {
    const { buildingId, ...otherData } = data;
    const response = await API.get<IConcreteBaseFinancials>(
      `/high-rise-sales/protected/building/${buildingId}/financials/concrete-base${getQeuryParams(otherData)}`,
      { headers }
    );
    let concreteBaseFinancials = response.data;
    return concreteBaseFinancials;
  } catch (err) {
    throw err;
  }
};

const getSalesUnitFinancials = async (
  data: IGetSalesUnitFinancialsRequestParams
): Promise<ISalesUnitFinancials> => {
  var headers = authHeader();
  try {
    const { salesUnitId, ...otherData } = data;
    const response = await API.get<ISalesUnitFinancials>(
      `/high-rise-sales/protected/sales-unit/${salesUnitId}/financials${getQeuryParams(otherData)}`,
      { headers }
    );
    let financials = response.data;
    return financials;
  } catch (err) {
    throw err;
  }
};

// STATUS
const getSalesUnitStatus = async (): Promise<IStatus[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IStatus[]>(`/high-rise-sales/protected/sales-unit-status`, {
      headers,
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

const createSalesUnitStatus = async (name: string): Promise<IStatus> => {
  var headers = authHeader();
  try {
    const response = await API.post<IStatus>(
      "/high-rise-sales/protected/sales-unit-status",
      { name },
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const hrsService = {
  getAllBuildings,
  createBuilding,
  updateBuilding,
  deleteBuilding,
  createSalesUnit,
  updateSalesUnit,
  deleteSalesUnit,
  getSalesUnitTypes,
  getBuildingFinancials,
  getBuildingsConsumableFinancials,
  getBuildingConcreteBaseFinancials,
  getSalesUnitFinancials,
  getSalesUnitStatus,
  createSalesUnitStatus,
};
